/** Line-numbered diff preview for OpenSpec deltas. `+` lines render on a
 *  green tint; `-` lines on a red tint; ` ` (context) lines on white.
 */
export function DiffPreview({ lines }: { lines?: { t: " " | "+" | "-"; text: string }[] }) {
  const data = lines ?? sampleLines();
  return (
    <div style={{ maxWidth: 880, margin: "0 auto" }}>
      <div
        className="card"
        style={{
          overflow: "hidden",
          fontFamily: "var(--mono)",
          fontSize: 12.5,
          lineHeight: 1.7,
        }}
      >
        {data.map((l, i) => {
          const bg =
            l.t === "+"
              ? "color-mix(in oklab, var(--ok) 12%, white)"
              : l.t === "-"
                ? "color-mix(in oklab, var(--err) 10%, white)"
                : "white";
          const col =
            l.t === "+"
              ? "var(--ok)"
              : l.t === "-"
                ? "var(--err)"
                : "var(--ink-3)";
          return (
            <div
              key={i}
              style={{
                display: "grid",
                gridTemplateColumns: "44px 18px 1fr",
                background: bg,
              }}
            >
              <span
                style={{
                  textAlign: "right",
                  padding: "0 8px",
                  color: "var(--ink-4)",
                  fontSize: 11,
                }}
              >
                {i + 1}
              </span>
              <span style={{ color: col, fontWeight: 600 }}>{l.t}</span>
              <span
                style={{
                  color: l.t === " " ? "var(--ink-2)" : "var(--ink)",
                  whiteSpace: "pre",
                }}
              >
                {l.text}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function sampleLines(): { t: " " | "+" | "-"; text: string }[] {
  return [
    { t: " ", text: "## Requirement: Sample requirement" },
    { t: " ", text: "" },
    { t: "-", text: "The system runs as a long-lived process." },
    { t: "+", text: "The system runs as an event-driven worker." },
    { t: "+", text: "" },
    { t: "+", text: "On interruption, in-flight work MUST be requeued" },
    { t: "+", text: "with idempotency-key = job_id." },
    { t: " ", text: "" },
    { t: " ", text: "### Scenario: Worker interrupted mid-job" },
    { t: "+", text: "  GIVEN a job has been running for less than its SLA" },
    { t: "+", text: "  WHEN an interruption signal is received" },
    { t: "+", text: "  THEN the job MUST be requeued with the same idempotency key" },
  ];
}
